export default {
    drawer: true,
    breadcrumbs: [],
    Auth: {
        Authorization: "",
        userDetail: "",
    },
    restoreStatus: false,
    app: {
        statusGrammarOfSection: false,
    },
    detailsSection: {},
    detailsGrammar: {
        Id: "",
        name: {},
        status: true,
        section: "",
        lead_sentence: {},
        comment: {},
        example: {},
        image: null,
        position: "Top",
        delf: false,
        numberExample: 0,
    },
    vocabularyGrammar: [],
    fields: {
        sentence_struct: [],
        challenge_sentence: {
            1: [],
            2: [],
            3: [],
        },
    },
    activeField: [],
    activeTabForFields: "elements",
    main: "Edit",
    // Grammar
    fieldsGrammar: [],
    activeFieldGrammar: {},
    activeTabForFieldsGrammar: "elements",
    mainGrammar: "Edit",
    isLanguage: "ja",

    // Expression
    fieldsExpression: [],
    tabExpression: "forms",
    activeFieldExpression: {},
    mainExpression: "Edit",
    isType: "Expression",
    isForm: "forms-expression",
    //  Sentence
    fieldsSentence: [],
    vocabularySentence: [],
    statusSentence: false,

    tab: "forms",
    elementMove: {},
    isElement: true,
    formGeneral: {
        leadSentence: "",
        name1: "",
        name2: "",
        name: [
            ["", ""]
        ],
        isAnsewr: 1,
        verb: "",
        kanji: "",
        audio: null,
        image: null,
        script: "",
        sub_question: {
            question1: {
                answers: [{
                        id: 1,
                        name: "回答1",
                        value: "",
                    },
                    {
                        id: 2,
                        name: "回答2",
                        value: "",
                    },
                    {
                        id: 3,
                        name: "回答3",
                        value: "",
                    },
                    {
                        id: 4,
                        name: "回答4",
                        value: "",
                    },
                ],
                script: "",
                audio: null,
                isAnsewr: 1,
            },
            question2: {
                answers: [{
                        id: 1,
                        name: "回答1",
                        value: "",
                    },
                    {
                        id: 2,
                        name: "回答2",
                        value: "",
                    },
                    {
                        id: 3,
                        name: "回答3",
                        value: "",
                    },
                    {
                        id: 4,
                        name: "回答4",
                        value: "",
                    },
                ],
                script: "",
                audio: null,
                isAnsewr: 1,
            },
        },
        answers: [{
                id: 1,
                name: "回答1",
                value: "",
            },
            {
                id: 2,
                name: "回答2",
                value: "",
            },
            {
                id: 3,
                name: "回答3",
                value: "",
            },
            {
                id: 4,
                name: "回答4",
                value: "",
            },
        ],
        answersConjugation: [{
                id: 1,
                value: "",
            },
            {
                id: 2,
                value: "",
            },
            {
                id: 3,
                value: "",
            },
            {
                id: 4,
                value: "",
            },
        ],
        wrongAnswersConjugation: [{
                id: 1,
                value: "",
            },
            {
                id: 2,
                value: "",
            },
            {
                id: 3,
                value: "",
            },
            {
                id: 4,
                value: "",
            },
        ],
    },
    editDetailSection: {
        statusEdit: false,
        isEdit: "",
        lead_sentence: [
            { text: "日本語", key: "ja", value: "", edit: false },
            { text: "日本語（かな）", key: "kana", value: "", edit: false },
            { text: "英語", key: "en", value: "", edit: false },
            { text: "中国語", key: "cn", value: "", edit: false },
            { text: "ベトナム語", key: "vn", value: "", edit: false },
            { text: "ベンガル語", key: "bn", value: "", edit: false },
            { text: "ポルトガル語", key: "pt", value: "", edit: false },
        ],
        goal: [
            { text: "日本語", key: "ja", value: "", edit: false },
            { text: "日本語（かな）", key: "kana", value: "", edit: false },
            { text: "英語", key: "en", value: "", edit: false },
            { text: "中国語", key: "cn", value: "", edit: false },
            { text: "ベトナム語", key: "vn", value: "", edit: false },
            { text: "ベンガル語", key: "bn", value: "", edit: false },
            { text: "ポルトガル語", key: "pt", value: "", edit: false },
        ],
    },
};